/**
 * Returns non-athlete users' phone #, preferring orgMembership.primaryPhone over user.phoneNumber if
 * user's org has axle sync enabled and user's org membership has been axle synced.
 */
const getDisplayPhone = ({
  isTeamworksUserManagementEnabled,
  membershipPhone,
  athletePhone,
  userPhone,
}: {
  isTeamworksUserManagementEnabled?: boolean;
  membershipPhone?: string | null;
  athletePhone?: string | null;
  userPhone?: string | null;
}): string | null =>
  isTeamworksUserManagementEnabled
    ? membershipPhone ?? null
    : athletePhone ?? userPhone ?? null;


export const getDisplayPhoneNumberFromUser = (
  user: { orgInfo?: unknown; phoneNumber?: string | null } | null | undefined
): string | null => {
  if (!user) return null;
  const { athlete, org, orgMembership } = (user.orgInfo as {
    athlete?: {
      phoneNumber?: string | null;
    }
    org?: {
      isAxleSyncEnabled?: boolean;
    }
    orgMembership?: {
      primaryPhone?: string | null;
      axlePersonDocumentId?: string | null;
    }
  } | undefined) ?? {};
  return getDisplayPhone({
    isTeamworksUserManagementEnabled: org?.isAxleSyncEnabled && !!orgMembership?.axlePersonDocumentId,
    membershipPhone: orgMembership?.primaryPhone,
    athletePhone: athlete?.phoneNumber,
    userPhone: user.phoneNumber,
  });
};

/**
 * Returns a membership's phone #, preferring primaryPhone over user.phoneNumber if
 * the org has axle sync enabled and the membership has been axle synced.
 */
export const getDisplayPhoneNumberFromFlattenedMembership = (
  membership: {
    primaryPhone?: string | null;
    phoneNumber?: string | null; // user.phoneNumber
  } | null | undefined,
  isTeamworksUserManagementEnabled: boolean
): string | null => {
  if (!membership) return null;
  return getDisplayPhone({
    isTeamworksUserManagementEnabled: isTeamworksUserManagementEnabled,
    membershipPhone: membership.primaryPhone,
    userPhone: membership.phoneNumber,
  });
};
